import { isDefined } from "../shared";

const PADDING_TOP = 25;
const PADDING_LEFT = 40;
const PADDING_RIGHT = 30;
const PADDING_BOTTOM = 30;

let _ctx = null;
let _clickedPoints = [];
let _width;
let _height;
let _axisYInfo;
let _chartData;

function inChartRange(point) {
  if (
    isDefined(point) &&
    point.x >= PADDING_LEFT &&
    point.x <= _width - PADDING_RIGHT &&
    point.y >= PADDING_TOP &&
    point.y <= _height - PADDING_BOTTOM
  ) {
    return true;
  } else {
    return false;
  }
}
function drawChart() {
  let validW = _width - PADDING_LEFT - PADDING_RIGHT;
  let validH = _height - PADDING_TOP - PADDING_BOTTOM;
  let realData = [];
  let xInterval = validW / _chartData.length;
  let yInterval = validH / (_axisYInfo.max - _axisYInfo.min);
  //
  for (let i = 0; i < _chartData.length; i++) {
    realData.push({
      x: i * xInterval,
      y: -yInterval * (_chartData[i] - _axisYInfo.min)
    });
  }

  let str = "";
  // 绘制X轴
  for (let i = 0; i <= _chartData.length; i += 20) {
    let x = 0;
    if (i >= _chartData.length) x = validW;
    else x = realData[i].x;
    str = i + "";
    let strW = _ctx.measureText(str).width;
    _ctx.beginPath();
    _ctx.moveTo(x, -validH);
    _ctx.lineTo(x, 0);
    _ctx.fillText(i, x - strW / 2, 20);
    _ctx.stroke();
  }
  // 绘制Y轴
  str = "μm";
  _ctx.lineWidth = 1;
  _ctx.strokeStyle = "rgba(255,255,255,0.1)";
  _ctx.fillText(str, -_ctx.measureText(str).width / 2, -_height + PADDING_TOP + 15);
  for (let i = 0; i <= _axisYInfo.num; i++) {
    let y = (-validH * i) / _axisYInfo.num;
    str = (_axisYInfo.min + (i * (_axisYInfo.max - _axisYInfo.min)) / _axisYInfo.num) * 1000;
    str = str._toFixed(0);
    let strW = _ctx.measureText(str).width;
    _ctx.beginPath();
    _ctx.moveTo(0, y);
    _ctx.lineTo(validW, y);
    _ctx.stroke();
    _ctx.fillText(str, -strW - 4, y + 8);
  }
  // 绘制数据
  _ctx.strokeStyle = "#bec0cc";
  _ctx.beginPath();
  for (let j = 0; j < realData.length; j++) {
    if (j === 0) {
      _ctx.moveTo(realData[j].x, realData[j].y);
    } else {
      _ctx.lineTo(realData[j].x, realData[j].y);
    }
  }
  _ctx.stroke();
}
function drawFocus(focus) {
  if (!inChartRange(focus)) return;

  let curX = focus.x - PADDING_LEFT;
  let index = parseInt(
    Math.round((curX * _chartData.length) / (_width - PADDING_LEFT - PADDING_RIGHT))
  );
  if (index >= _chartData.length) {
    return;
  }
  let curVal = `${index}: ${(_chartData[index] * 1000)._toFixed(0)}`;
  // let strW = _ctx.measureText(curVal).width
  // let curY =
  //   -(
  //     (_height - PADDING_TOP - PADDING_BOTTOM) /
  //     (_axisYInfo.max - _axisYInfo.min)
  //   ) *
  //   (_chartData[index] - _axisYInfo.min)

  _ctx.beginPath();
  // _ctx.moveTo(0, curY)
  // _ctx.lineTo(curX, curY)
  _ctx.moveTo(curX, 0);
  _ctx.lineTo(curX, -_height + PADDING_TOP + PADDING_BOTTOM);
  _ctx.stroke();
  _ctx.fillText(curVal, 1, -1);
}
function drawClicked(clicked) {
  if (inChartRange(clicked)) {
    if (_clickedPoints.length >= 2) {
      _clickedPoints = [];
    }
    let curX = clicked.x - PADDING_LEFT;
    let index = parseInt(
      Math.round((curX * _chartData.length) / (_width - PADDING_LEFT - PADDING_RIGHT))
    );
    _clickedPoints.push({ x: curX, data: _chartData[index] });
  }
  for (let i = 0; i < _clickedPoints.length; i++) {
    _ctx.beginPath();
    _ctx.moveTo(_clickedPoints[i].x, 0);
    _ctx.lineTo(_clickedPoints[i].x, -(_height - PADDING_TOP - PADDING_BOTTOM));
    _ctx.stroke();
  }
  if (_clickedPoints.length >= 2) {
    let diff = `Diff = ${((_clickedPoints[1].data - _clickedPoints[0].data) * 1000)._toFixed(0)}`;
    _ctx.fillText(
      diff,
      (_clickedPoints[0].x + _clickedPoints[1].x - _ctx.measureText(diff).width) / 2,
      -10
    );
  }
}

export function draw(canvas, ctx, chartData, axisYInfo, focus, clicked) {
  if (!isDefined(canvas) || !isDefined(ctx)) {
    return;
  }
  // 清除绘制
  canvas.height = canvas.height;
  if (!isDefined(chartData)) {
    return;
  }
  _ctx = ctx;
  _width = canvas.width;
  _height = canvas.height;
  _axisYInfo = axisYInfo;
  _chartData = chartData;

  _ctx.fillStyle = "#bec0cc"; // 'rgba(255,255,255,0.7)'
  _ctx.font = "18px serif";
  _ctx.lineWidth = 1;
  _ctx.strokeStyle = "rgba(255,255,255,0.1)";
  _ctx.translate(PADDING_LEFT, _height - PADDING_BOTTOM);
  drawChart();

  _ctx.fillStyle = "rgba(255,255,0,0.6)";
  _ctx.strokeStyle = "rgba(255,255,0,0.6)";
  _ctx.setLineDash([4, 6]);
  _ctx.lineDashOffset = 2;
  drawFocus(focus);
  drawClicked(clicked);

  ctx.translate(-PADDING_LEFT, -_height + PADDING_BOTTOM);
}

export function clearClicked() {
  _clickedPoints = [];
}



// WEBPACK FOOTER //
// ./src/topography/js/RiseArchDrawn.js